export const blsDatePickerOptions = {
  dateFormat: "d-m-Y",
  monthSelectorType: "static",
  disableMobile: true,
  onReady: (selectedDates, dateStr, instance) => {
    const calendar = instance.calendarContainer;
    calendar.classList.add("bls-calendar");
    if (calendar.querySelector(".flatpickr-footer")) return;

    const footer = document.createElement("div");
    footer.className = "flatpickr-footer";

    const clear = document.createElement("button");
    clear.type = "button";
    clear.className = "flatpickr-footer-btn";
    clear.textContent = "Clear";
    clear.addEventListener("click", (event) => {
      event.preventDefault();
      instance.clear();
    });

    const today = document.createElement("button");
    today.type = "button";
    today.className = "flatpickr-footer-btn";
    today.textContent = "Today";
    today.addEventListener("click", (event) => {
      event.preventDefault();
      instance.setDate(new Date(), true);
    });

    footer.append(clear, today);
    calendar.append(footer);
  },
};
